import * as actionTypes from './actionTypes';

export const connectToWebSocket = () => ({
    type: actionTypes.CONNECT_TO_WEBSOCKET
});

export const setWebSocket = socket => ({
    type: actionTypes.SET_WEBSOCKET,
    socket
});

export const authenticate = () => ({
    type: actionTypes.AUTHENTICATE
});